import './FilterModels.css';const filterModelsCollapse = "_filterModelsCollapse_x97vv_1";
const filterModelsCollapse__brandHeader = "_filterModelsCollapse__brandHeader_x97vv_5";
const filterModelsCollapse__brandTitle = "_filterModelsCollapse__brandTitle_x97vv_14";
const filterModelsCollapse__brandDescription = "_filterModelsCollapse__brandDescription_x97vv_69";
const styles = {
  filterModelsCollapse,
  filterModelsCollapse__brandHeader,
  filterModelsCollapse__brandTitle,
  filterModelsCollapse__brandDescription
};
export {
  styles as default,
  filterModelsCollapse,
  filterModelsCollapse__brandDescription,
  filterModelsCollapse__brandHeader,
  filterModelsCollapse__brandTitle
};
